const uuidv4 = require('uuid').v4;

/**
 * Clase DomainEventData
 */
class DomainEventData {
  constructor() {
    this.id = uuidv4().toString();
  }
}

module.exports = DomainEventData;
